import React from "react";
import {isMe, ShowcaseItem, ShowcaseItems, UserProfile} from "../types";
import {ShowcaseItemsView} from "./Components";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {PD_SM} from "../../shared/dimens";
import {BaseShowcaseFragment} from "../BaseShowcaseFragment";

export class PortfolioFragment extends BaseShowcaseFragment {

  private loader: ShowcaseItems;

  protected async fetchOnMount(forceReload?: boolean): Promise<void> {
    const userProfile: UserProfile = await super.fetchOnMount(forceReload);
    if (userProfile) {
      if (!this.loader || forceReload) {
        this.loader = ShowcaseItems.getMemberInstance(userProfile.member.memberId);
      }
      await this.loader?.loadListItems();
    }
  }

  protected renderPageContent(): React.ReactElement | null {
    let items = this.loader.getListItems();
    if (!(items?.length > 0)) {
      items = new Array(12).fill("_").map(val => ShowcaseItem.PLACEHOLDER);
      if (isMe(this.state.userProfile)) {
        items[0] = ShowcaseItem.UPLOAD;
      }
    }
    return <StyledBoxColumn style={{marginTop: PD_SM}}>
      <ShowcaseItemsView path={this.props.path} items={items}/>
    </StyledBoxColumn>;
  }
}